import autosize from 'autosize'

autosize(document.querySelectorAll('.js-c-form-input--textarea'))